import styled from "@emotion/styled";
import React from "react";
import { match } from "ts-pattern";
import { ComplianceCardData, getItemStatus } from "../../../utils/complianceUtils";
import { doNothing } from "../../../utils/doNothing";
import CircleIcon from "../../CircleIcon";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import NextButton from "../../NextButton/NextButton";
import { CircleShimmer, TextShimmer } from "../../Shimmer";
import ComplianceCircleIcon from "./ComplianceCircleIcon";

type Props =
  | {
      isLoading: true;
    }
  | (ComplianceCardData & {
      isLoading: false;
      onClick: () => void;
    });

function ComplianceItemStatusCard(props: Props) {
  const color = props.isLoading
    ? "transparent"
    : match(props.type)
        .with("issue", () => "var(--red)")
        .with("expiresSoon", () => "var(--orange)")
        .with("dueSoon", () => "var(--orange)")
        .with("compliant", () => "var(--green)")
        .with("pending", () => "var(--orange)")
        .exhaustive();

  if (props.isLoading) {
    return (
      <ComplianceItemStatusCard.Styled onClick={doNothing}>
        <AppCardContent>
          <CircleIcon.Wrapper color={color}>
            <CircleShimmer width={40} height={40} />
          </CircleIcon.Wrapper>
          <ComplianceItemStatusCard.ContentWrapper>
            <ComplianceItemStatusCard.Title>
              <TextShimmer width={40} height={16} />
            </ComplianceItemStatusCard.Title>
            <ComplianceItemStatusCard.Subtitle>
              <TextShimmer width={90} height={14} />
            </ComplianceItemStatusCard.Subtitle>
          </ComplianceItemStatusCard.ContentWrapper>
          <NextButton />
        </AppCardContent>
      </ComplianceItemStatusCard.Styled>
    );
  }

  return (
    <ComplianceItemStatusCard.Styled onClick={props.onClick}>
      <AppCardContent>
        <ComplianceCircleIcon color={color} type={props.type} />
        <ComplianceItemStatusCard.ContentWrapper>
          <ComplianceItemStatusCard.Title>
            {getItemStatus(props.item)}
          </ComplianceItemStatusCard.Title>
          <ComplianceItemStatusCard.Subtitle>{props.subTitle}</ComplianceItemStatusCard.Subtitle>
        </ComplianceItemStatusCard.ContentWrapper>
      </AppCardContent>
    </ComplianceItemStatusCard.Styled>
  );
}

ComplianceItemStatusCard.ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

ComplianceItemStatusCard.Title = styled.span`
  font-size: 16px;
`;

ComplianceItemStatusCard.Subtitle = styled.span`
  color: var(--gray-500);
  font-size: 14px;
`;

ComplianceItemStatusCard.Styled = styled(AppCard)`
  .AppCardContent {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  ${NextButton.Styled} {
    flex-shrink: 0;
  }

  ${ComplianceItemStatusCard.ContentWrapper} {
    flex: 1;
  }
`;

export default ComplianceItemStatusCard;
